import {
  InitialConfigType,
  LexicalComposer,
} from '@lexical/react/LexicalComposer';
import { Editor as InternalEditor, EditorProps } from './Editor';
import EditorTheme from './themes/EditorTheme';
import { AutoLinkNode, LinkNode } from '@lexical/link';
import { ListItemNode, ListNode } from '@lexical/list';
import { HeadingNode, QuoteNode } from '@lexical/rich-text';

const initialConfig: InitialConfigType = {
  namespace: 'editor',
  theme: EditorTheme,
  onError: (error) => {
    throw error;
  },
  nodes: [
    HeadingNode,
    ListNode,
    ListItemNode,
    QuoteNode,
    AutoLinkNode,
    LinkNode,
  ],
};
export const Editor = (props: EditorProps) => {
  return (
    <LexicalComposer initialConfig={initialConfig}>
      <InternalEditor {...props} />
    </LexicalComposer>
  );
};
